<template>
	<div class="dev-container container" :class="'dev-container-' + currentPage">
		<dev-failonpurpose-view v-if="currentPage === 'failOnPurpose'" />
	</div>
</template>

<script>
	import * as MutationTypes from '@/store/mutation-types'
	import { mapGetters } from 'vuex'

	import DevFailOnPurposeView from '@/views/flow/dev/00-FailOnPurpose.vue';

	const pageComponentDefault = 'failOnPurpose';

	export default {
		name: 'dev-view',
		components: {
			'dev-failonpurpose-view': DevFailOnPurposeView,
		},
		computed: {
			currentPage() {
				let page = this.$route.meta.childPage;

				if (typeof(page) !== 'string' || page === '') {
					page = pageComponentDefault;
				}

				return page;
			},
		},
	}
</script>

<style lang="scss" scoped>
	.client-container {
	}
</style>
